import { InfoIcon } from "@phosphor-icons/react/Info";
import { Callout } from "@freightsimple/ui-core/Display/Callout";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";
import { lineItemsLimitExplanation } from "../Helpers/lineItemsLimitExplanation";

interface LineItemsLimitReachedNoteProps {
  maxLineItems: number;
}

export function LineItemsLimitReachedNote(
  props: LineItemsLimitReachedNoteProps,
) {
  return (
    <div data-testid="line-items-limit-note">
      <Callout>
        <Row gap={2} align="start" shrinkable>
          <Icon icon={InfoIcon} weight="fill" color="text-blue" />
          <T size="sm" color="secondary">
            {lineItemsLimitExplanation(props.maxLineItems)}
          </T>
        </Row>
      </Callout>
    </div>
  );
}
